import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const NotificationTranslationKeys = {
  contentCopiedToClipboard: translationKey('snackbar_content_copied_to_clipboard'),
  createReportIssuesStillLoading: translationKey('snackbar_create_report_issues_still_loading'),
  createReportTooLessIssues: translationKey('snackbar_create_report_too_less_issues'),
  createReportTooManyIssues: translationKey('snackbar_create_report_too_many_issues'),
  editLocationAreaAreaLimitReached: translationKey('snackbar_edit_location_area_area_limit_reached'),
  editLocationAreaPointLimitReached: translationKey('snackbar_edit_location_area_point_limit_reached'),
  editLocationDeleteAreaNotSelected: translationKey('snackbar_edit_location_delete_area_not_selected'),
  editLocationSaveAreaNotFinished: translationKey('snackbar_edit_location_save_area_not_finished'),
  mobileAppAvailable: translationKey('snackbar_mobile_app_available'),
  noInternetConnection: translationKey('snackbar_no_internet_connection'),
  nothingMoreToLoad: translationKey('snackbar_nothing_more_to_load'),
  somethingWentWrong: translationKey('toaster_something_went_wrong'),
  accessCannotChangeBecauseOfProcess: translationKey('tooltip_access_cannot_change_because_of_process'),
  accessCannotChangeBecauseOfSite: translationKey('tooltip_access_cannot_change_because_of_site'),
  accessCannotChangeForManagerOrAdmin: translationKey('tooltip_access_cannot_change_for_manager_or_admin'),
  accessCannotChangeForVisibleNoAccess: translationKey('tooltip_access_cannot_change_for_visible_no_access'),
  accessSelfEditUnavailable: translationKey('tooltip_access_self_edit_unavailable'),
  actionDisabledIssueDeleted: translationKey('tooltip_action_disabled_issue_deleted'),
  actionForbidden: translationKey('tooltip_action_forbidden'),
  cannotEditClientAdminPermissionsOnProject: translationKey('tooltip_cannot_edit_client_admin_permissions_on_project'),
  cannotEditEmail: translationKey('tooltip_cannot_edit_email'),
  downloadFile: translationKey('tooltip_download_file'),
  drawing: translationKey('tooltip_drawing'),
  emailDisabled: translationKey('tooltip_email_disabled'),
  fullscreenEnter: translationKey('tooltip_fullscreen_enter'),
  fullscreenLeave: translationKey('tooltip_fullscreen_leave'),
  issueFormDependedNotFilled: translationKey('tooltip_issue_form_depended_not_filled'),
  multiselectIsNotSortable: translationKey('tooltip_multiselect_is_not_sortable'),
  personalDataDisabledOtherProjects: translationKey('tooltip_personal_data_disabled_other_projects'),
  processHasAccess: translationKey('tooltip_process_has_access'),
  processNoAccess: translationKey('tooltip_process_no_access'),
  removeUserCompletelyFromOrganization: translationKey('tooltip_remove_user_completely_from_organization'),
  removeUserCompletelyFromProject: translationKey('tooltip_remove_user_completely_from_project'),
  revokeInBothDisabledNoAccess: translationKey('tooltip_revoke_in_both_disabled_no_access'),
  revokeInOrganization: translationKey('tooltip_revoke_in_organization'),
  revokeInProject: translationKey('tooltip_revoke_in_project'),
  siteHasAccess: translationKey('tooltip_site_has_access'),
  siteNoAccess: translationKey('tooltip_site_no_access'),
  userEditDisabledHigherRole: translationKey('tooltip_user_edit_disabled_higher_role'),
  userEditDisabledSuperadmin: translationKey('tooltip_user_edit_disabled_superadmin'),
} as const satisfies Record<string, TranslationKey>;
